// export const backendlink = "https://poc.ausculto.com.hk";
// export const backendlink = "https://vitomeadminportal.azurewebsites.net/";
// export const backendlink = "http://localhost:7777/";

// export const backendlink = "https://rhythm-adminbackend.azurewebsites.net/";
// export const backendlink = process.env.BACKENDLINK;
export const backendlink = "https://adminbackend-k8s.vitome.com/";